(function (app, ng) {
    app.provider("eligibilityFormDialog", [function () {
        this.$get = ["$mdDialog", "$q", "eligibilityFormApi", "_", "states", function ($mdDialog, $q, eligibilityFormApi, _, states) {
            return {
                open: function (event, surveyId, disclaimer) {
                    var promises = [];
                    var returnObj = {states: states};

                    promises.push(eligibilityFormApi.getSurvey(surveyId).then(function (response) {
                        var radioLists = [];
                        var radioListQuestions = [];

                        response.Questions.forEach(function (q) {
                            var delim = "|";
                            var arr;

                            if (q.SurveyQuestionType === "Textarea") {
                                arr = q.SurveyQuestionText.split(delim);

                                q.Question = arr[0];
                                q.TextDescription = arr[1];
                            } else if (q.SurveyQuestionType === "RadioList") {
                                arr = q.SurveyQuestionText.split(delim);

                                if (!radioLists[arr[0]])
                                    radioLists[arr[0]] = [];

                                var listItem = _.find(radioListQuestions, { SurveyQuestionText: arr[0] });

                                if (!listItem) {
                                    q.QuestionIds = [q.SurveyQuestionId];
                                    q.SurveyQuestionText = arr[0];
                                    radioListQuestions.push(q);
                                } else {
                                    listItem.QuestionIds.push(q.SurveyQuestionId);
                                }

                                radioLists[arr[0]].push({
                                    SurveyQuestionId: q.SurveyQuestionId,
                                    Question: arr[1],
                                    PossibleAnswers: q.PossibleAnswers,
                                    IsRequired: q.IsRequired
                                });
                            }
                        });

                        radioListQuestions.forEach(function (q) {
                            response.Questions = _.reject(response.Questions,
                                function (question) {
                                    return q.QuestionIds.indexOf(question.SurveyQuestionId) !== -1;
                                });

                            response.Questions.push(q);
                        });

                        returnObj.radioLists = radioLists;
                        returnObj.enrollment = response;
                    }));

                    promises.push(eligibilityFormApi.getSalesConsultants().then(function (response) {
                        returnObj.salesConsultants = response;                        
                    }));

                    return $q.all(promises).then(function () {
                        return $mdDialog.show({
                            bindToController: true,
                            controllerAs: "$ctrl",
                            controller: "dialogCtrl",
                            templateUrl: "App/Enrollment/Programs.html",
                            parent: ng.element(document.body),
                            targetEvent: event,
                            clickOutsideToClose: false,
                            locals: {
                                enrollment: returnObj.enrollment,
                                radioLists: returnObj.radioLists,
                                salesConsultants: returnObj.salesConsultants,
                                resource: returnObj.resource,
                                states: returnObj.states,
                                surveyId: surveyId,
                                disclaimer: disclaimer
                            }
                        }).then(function (response) {
                            
                            returnObj.submitted = response;

                            if (response)
                                returnObj.submittedSurveyId = surveyId;

                            return returnObj;
                        });
                    });
                }
            };
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line